import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import { Autocomplete, Box, Button, Chip, Grid, Paper, TextField, Tooltip, Typography } from '@mui/material';
import ActionDetails from '../../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../../components/mui/GlobalAnchor/GlobalAnchorList';
import InduvidualAssessmentReport from '../../../assessmentReportInduvidual/InduvidualAssessmentReport';
import { useSelector } from 'react-redux';
import { NewCrdAdmissionRegisterTableHead } from '../../../../components/datagrid/CRD/NewAdmissionRegister/NewCrdAdmissionRegisterTableHead';
import ProfileViewAdmissionRegister from '../../../../components/datagrid/myworkspace/ogd/AdmissionRegister/ProfileViewAdmissionRegister';
import {
  clearStudentProfile,
  getAdmissionRegisterDataForFinance,
  getAdmissionRegisterDataforPQA,
  getAllActiveCourses,
  getAllCroList,
  getAllCroLists,
  getCROlistUnderProject,
  getDataForCrdAdmissionRegister,
  getStudentsProfileForCRD,
} from '../../../../redux/features/CRDslice';
import { useNavigate } from 'react-router-dom';
import CROleadsView from '../../../cro/myworkspace/CROleads/CROleadsView';
import Feepersession from './components/Feepersession';
import UpdateStudent from './UpdateStudent';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import dayjs from 'dayjs';
import WhatsappShare from './WhatsappShare';
import { useDispatch } from 'react-redux';
import SubjectAndTotalsession from './components/TotalSession';
import CourseCertificate from './components/CourseCertificate';
import CourseEnrollStatus from './components/CourseEnrollStatus';
import Cronotes from './components/CROnotes';
import EvaluationTrackerLanding from './EvaluationTracker/EvaluationTrackerLanding';
import { getCourseAvailable, getProjectsPreData } from '../../../../redux/features/mastersSlice';
import { getCroList } from '../../../../redux/features/crmSlice';
import { getAvailableCourses } from '../../../../redux/features/coursesSlice';
import { getCrolistunderCrm } from '../../../../redux/features/srtSlice';
import TerminationClearenceCRD from './components/TerminationClearence';
import SessionLog from './components/SessionLog';
import SessionLogCRO from './components/SessionLogcro';
import OGARemarks from './components/OGAremarks';
import CopyDataToSheet from '../../../../components/CopyDataToSheet';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';
import { getClasses, getSubjects } from '../../../../redux/features/croSlice';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import GlobalDialogueContent from '../../../../components/GlobalDialogueContent';
import AdmissionStatusCRM from './components/AdmissionStatusCRM';
import ChangeCourseAction from '../courseChange/ChangeCourseAction';

const status = [
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
  { id: 2, name: 'Temporarly Inactive' },
];
const forecastTypes = [
  { id: null, name: 'All' },
  { id: 1, name: 'System' },
  { id: 2, name: 'Manual' },
];
const NewAdmissionRegisterLanding = ({ cro, crm, pqa, finance }) => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search, sortModel } = paginationData;
  const {
    loading,
    activeCourses,
    croList,
    allcrolist,
    admissionRegisterData,
    admissionRegisterDataPQA,
    admissionRegisterDataFinance,
    crosunderproject,
    admissionRegisterDataGridExtraLoading,
  } = useSelector((store) => store.crd);
  const { loading: masterLoading, projectsPreData } = useSelector((state) => state.masters);
  const { loading: srtLoading, crolistundercrm } = useSelector((state) => state.srt);

  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const navigate = useNavigate();
  const [selectedYear, setSelectedYear] = useState(dayjs().format('YYYY'));
  const [selectedProjectId, setSelectedProjectId] = useState({
    id: null,
    name: 'All',
  });
  const [selectedCourseId, setSelectedCourseId] = useState({
    id: null,
    courseName: 'All',
  });
  const [selectedCroId, setSelectedCroId] = useState({
    userID: null,
    name: 'All',
  });
  const [currentRowDetails, setCurrentRowDetails] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState(1);
  const [selectedForecast, setSelectedForecast] = useState(null);
  const [openModalComponentName, setOpenModalComponentName] = useState('');
  const [selectedForActivating, setSelectedForActivating] = useState({ id: '', status: '' });

  const month = String(new Date().getMonth() + 1).padStart(2, '0');
  const isResettingPage = useRef(false);

  const dispatch = useDispatch();
  const handleProjectChange = (e, option) => {
    setSelectedProjectId(option);
  };
  const handleCourseChange = (e, option) => {
    setSelectedCourseId(option);
  };
  const handleCroChange = (e, option) => {
    setSelectedCroId(option);
  };
  const handleStatusChange = (e, option) => {
    setSelectedStatusId(option?.id || '');
  };
  const handleType = (e, option) => {
    setSelectedForecast(option);
  };
  const dispatchParams = {
    selectedYear,
    selectedProjectId,
    selectedCourseId,
    selectedCroId,
    selectedStatusId,
    paginationData,
    search,
    sortModel,
    ...(pqa && { deptID: profile?.departmentId }),
    ...(finance && { typeID: selectedForecast?.id }),
  };
  const ExportParams = {
    selectedYear,
    selectedProjectId,
    selectedCourseId,
    selectedCroId,
    selectedStatusId,
    paginationData: {
      ...paginationData,
      gridSize: 'no',
    },
    ...(pqa && { deptID: profile?.departmentId }),
    ...(finance && { typeID: selectedForecast?.id }),
  };

  useEffect(() => {
    dispatch(getSubjects());
    dispatch(getClasses());
    dispatch(getProjectsPreData());
    dispatch(getAllActiveCourses());
    dispatch(getSubjects());
    dispatch(getClasses());
    dispatch(getCROlistUnderProject(profile?.departmentId));
    dispatch(getAllCroList());
    dispatch(getCrolistunderCrm({ crmId: null }));
  }, []);

  //..................IT IS DEPENDECY FOR PAGE RESET TO PAGE NUMBER 1......................///
  useEffect(() => {
    isResettingPage.current = true;
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [search, selectedProjectId, selectedCourseId, selectedCroId, selectedStatusId, selectedYear, selectedForecast]);
  //........................................///

  useEffect(() => {
    if (pageNum && gridSize) {
      let apiToCall;

      if (pqa) {
        apiToCall = getAdmissionRegisterDataforPQA;
      } else if (finance) {
        apiToCall = getAdmissionRegisterDataForFinance;
      } else {
        apiToCall = getDataForCrdAdmissionRegister;
      }

      if (isResettingPage.current) {
        if (pageNum == 1) {
          dispatch(apiToCall(dispatchParams));
        }
        isResettingPage.current = false;
        return;
      } else {
        dispatch(apiToCall(dispatchParams));
      }
    }
  }, [
    pageNum,
    gridSize,
    selectedYear,
    selectedProjectId,
    selectedCourseId,
    selectedCroId,
    selectedStatusId,
    search,
    sortModel?.field,
    sortModel?.order,
    selectedForecast,
    pqa,
    finance,
    dispatch,
  ]);
  useEffect(() => {
    if (!openAnchor) {
      //CLEARING PREVIOS LOADED STUDENT PROFILE
      dispatch(clearStudentProfile());
    }
  }, [openAnchor]);
  const handlenavigate = useCallback(() => {
    const url = `/my-workspace/student-attendance-view?admissionNo=${rowData?.admn_no}&studentName=${rowData?.student_name}&course=${rowData?.course_name}&courseEnrollmentId=${rowData?.course_enrollment_id}&total_sessions=${rowData.total_sessions}`;
    window.open(url, '_blank');
  }, [rowData]);

  const handlenavigateLedger = useCallback(() => {
    const url = `/my-workspace/ledger-view-cro?admissionNo=${rowData?.admn_no}&studentName=${rowData?.student_name}&course=${rowData?.course_name}&courseEnrollmentId=${rowData?.course_enrollment_id}`;
    window.open(url, '_blank');
  }, [rowData]);

  const mappingTrainerParams = new URLSearchParams({
    courseEnrollmentId: rowData?.course_enrollment_id,
    crm: crm ? 'true' : false,
    leadDetails: JSON.stringify(rowData),
  });
  const MappingTrainerEncoded = btoa(mappingTrainerParams.toString()); // base64 encoding

  function withTooltip(columns) {
    return columns.map((col) => {
      // Keep the original renderCell if it exists
      const originalRenderCellFuncion = col?.renderCell;

      return {
        ...col,
        renderCell: (params) => {
          const rendered = originalRenderCellFuncion ? originalRenderCellFuncion(params) : <span>{params.value}</span>;
          const content = React.isValidElement(rendered) ? rendered : <span>{rendered}</span>;
          return <Tooltip title={`Student: ${params.row.student_name}`}>{content}</Tooltip>;
        },
      };
    });
  }

  const contentRenderFunction = (title) => {
    const component = modalComponents.find((c) => c.title === title);
    return component ? component.content : null;
  };

  const modalComponents = useMemo(
    () => [
      {
        title: 'Course Enrollment Status',

        content: (
          <AdmissionStatusCRM
            status={selectedForActivating?.status}
            id={selectedForActivating?.id}
            setOpenModalComponentName={setOpenModalComponentName}
            dispatchParams={dispatchParams}
            dispatchFn={getDataForCrdAdmissionRegister}
            loading={loading}
          />
        ),
      },
    ],
    [selectedForActivating, loading, dispatchParams]
  );

  const gridData = pqa ? admissionRegisterDataPQA : finance ? admissionRegisterDataFinance : admissionRegisterData;

  const croAutomcomplete = pqa ? crosunderproject : finance ? allcrolist : crolistundercrm;
  console.log("rowdata",rowData);
  
  return (
    <GlobalWrapper
      title={'Admission Register'}
      // actions={
      //   <>
      //     <Button
      //       variant="contained"
      //       onClick={() =>
      //         window.open(
      //           `https://workspace.teaminterval.net/student/expected_sessions/-1/${selectedYear}/${month}`,
      //           "_blank"
      //         )
      //       }
      //     >
      //       Update Expected Sessions
      //     </Button>
      //   </>
      // }
    >
      <Box>
        <GlobalDialog
          title={openModalComponentName}
          open={Boolean(openModalComponentName)}
          setOpen={setOpenModalComponentName}
          closeButton={true}
          content={contentRenderFunction(openModalComponentName)}
          // maxWidth={"md"}
        />
        <Grid container spacing={2}>
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box flex={1}>
              <DatePickerCustom
                fullWidth={true}
                value={dayjs(selectedYear)}
                setValue={(date) => setSelectedYear(date.format("YYYY"))}
                viewDetails={["year"]}
                error={false}
              />
            </Box>
          </Grid> */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            {/* <Box
              flex={1}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "58px",
                  overflow: "auto",
                  border: "1px solid #0000001f",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                },
              }}
            >
              <Autocomplete
                multiple
                fullWidth
                name="projectId"
                options={projects}
                getOptionLabel={(option) => option.name || ""}
                value={selectedProjectId}
                onChange={handleProjectChange}
                renderInput={(params) => (
                  <TextField
                    disabled
                    fullWidth
                    autoComplete="off"
                    {...params}
                    label="Projects"
                    sx={{
                      "& .MuiInputLabel-root.MuiInputLabel-shrink": {
                        marginTop: "-6px",
                      },
                    }}
                  />
                )}
              />
            </Box> */}

            <Box flex={1}>
              <Autocomplete
                fullWidth
                name="projectId"
                options={[{ id: null, name: 'All' }, ...projectsPreData]}
                getOptionLabel={(option) => option.name || ''}
                value={selectedProjectId}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={handleProjectChange}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Projects" />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box flex={1}>
              <Autocomplete
                fullWidth
                name="courseId"
                options={[{ id: null, courseName: 'All' }, ...activeCourses]}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.courseName || ''}
                value={selectedCourseId}
                onChange={handleCourseChange}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Courses" />
                )}
              />
            </Box>
          </Grid>
          {crm || pqa || finance ? (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Box flex={1}>
                <Autocomplete
                  fullWidth
                  name="croId"
                  options={[{ userID: null, name: 'All' }, ...croAutomcomplete]}
                  getOptionLabel={(option) => option.name || ''}
                  value={selectedCroId}
                  onChange={handleCroChange}
                  isOptionEqualToValue={(option, value) => option.userID === value.userID}
                  renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="CRO" />}
                />
              </Box>
            </Grid>
          ) : null}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box flex={1}>
              <Autocomplete
                fullWidth
                name="statusId"
                options={status}
                getOptionLabel={(option) => option.name || ''}
                value={status?.find((status) => status?.id == selectedStatusId) || null}
                onChange={handleStatusChange}
                renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Status" />}
              />
            </Box>
          </Grid>
          {finance && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Box flex={1}>
                <Autocomplete
                  fullWidth
                  name="typeID"
                  options={forecastTypes}
                  getOptionLabel={(option) => option.name || ''}
                  value={forecastTypes?.find((status) => status?.id == selectedForecast?.id) || null}
                  onChange={handleType}
                  renderInput={(params) => (
                    <TextField disabled fullWidth autoComplete="off" {...params} label="Forecast Type" />
                  )}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box mt={1}>
        <Paper>
          <CopyDataToSheet
            api={
              pqa
                ? getAdmissionRegisterDataforPQA
                : finance
                ? getAdmissionRegisterDataForFinance
                : getDataForCrdAdmissionRegister
            }
            data={dispatchParams}
            paramsChange={true}
            otherParams={ExportParams}
            loading={loading}
          />
          {currentRowDetails?.student_name && (
            <Chip
              variant="outlined"
              color="secondary"
              sx={{ mt: 0.5, mb: 0.5 }}
              label={`Student Name : ${currentRowDetails?.student_name}`}
            />
          )}

          <GlobalDatagrid
            // tableHead={withTooltip(NewCrdAdmissionRegisterTableHead(crm,cro))}
            tableHead={NewCrdAdmissionRegisterTableHead(
              crm,
              finance,
              dispatchParams,
              setOpenModalComponentName,
              setSelectedForActivating,
              cro
            )}
            rows={gridData?.data}
            meta={gridData?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading || admissionRegisterDataGridExtraLoading}
            rowClick={true}
            setCurrentRowDetails={setCurrentRowDetails}
            actionComponent={
              <>
                <ActionDetails val={rowData?.student_name} />
                <GlobalAnchorList
                  label={rowData?.is_student_new ? 'Add Session Preference' : 'Update Expected Sessions'}
                  component={
                    <Tooltip title={rowData?.is_student_new ? 'New Admission' : 'Old Admission'}>
                      <span>
                        <Button
                          disabled={false}
                          size="small"
                          onClick={() => {
                            rowData?.is_student_new
                              ? window.open(
                                  `/my-workspace/session-preference?courseenrollmentId=${rowData?.course_enrollment_id}&studentname=${rowData?.student_name}&phone=${rowData?.student_mob_no}&course=${rowData?.course_name}`,
                                  '_blank'
                                )
                              : window.open(
                                  `https://workspace.teaminterval.net/student/expected_sessions/-1/${selectedYear}/${month}`,
                                  '_blank'
                                );
                          }}
                          variant="outlined"
                        >
                          <Icon
                            style={{ marginRight: '3px' }}
                            icon="material-symbols:right-click-rounded"
                            width="20"
                            height="20"
                          />
                          <Typography variant="button">Click</Typography>
                        </Button>
                      </span>
                    </Tooltip>
                  }
                />

                <GlobalAnchorList
                  component={
                    <Tooltip title={rowData?.is_calendar_exists == 1 ? '' : 'Calendar Not Exist'}>
                      <Box>
                        <Button
                          disabled={rowData?.is_calendar_exists != 1}
                          sx={{
                            p: '7px',
                            px: '10px',
                            background: 'linear-gradient(135deg,rgb(7, 113, 219),rgba(4, 5, 5, 0.43))',
                            color: '#fff',
                            '&:hover': {
                              background: 'linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))',
                            },
                          }}
                          onClick={() =>
                            window.open(`/my-workspace/academic-calendar?leadId=${rowData?.lead_id}`, '_blank')
                          }
                          variant="outlined"
                        >
                          <Icon icon="mdi:eye" width="20" height="20" />
                          Academic Calendar
                        </Button>
                      </Box>
                    </Tooltip>
                  }
                />
                <GlobalAnchorList
                  component={
                    <Tooltip title={rowData?.is_calendar_exists == 1 ? '' : 'Calendar Not Exist'}>
                      <Box>
                        <Button
                          disabled={rowData?.is_calendar_exists != 1}
                          sx={{
                            p: '7px',
                            px: '10px',
                            background: 'linear-gradient(135deg,rgb(7, 113, 219),rgba(4, 5, 5, 0.43))',
                            color: '#fff',
                            '&:hover': {
                              background: 'linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))',
                            },
                          }}
                          onClick={() =>
                            window.open(`/my-workspace/academic-calendar-edit?leadId=${rowData?.lead_id}`, '_blank')
                          }
                          variant="outlined"
                        >
                          <Icon icon="mdi:eye" width="20" height="20" />
                          Calendar Edit
                        </Button>
                      </Box>
                    </Tooltip>
                  }
                />

                <GlobalAnchorList
                  component={
                    <InduvidualAssessmentReport
                      disabled={rowData?.assessment_report_file_exists != 1}
                      sx={{
                        p: '7px',
                        background: 'linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))',
                        color: '#fff',
                        '&:hover': {
                          background: 'linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))',
                        },
                      }}
                      leadId={rowData?.lead_id}
                      buttonName={'Assessment Report'}
                      btnIcon={<Icon icon="mdi:eye" width="20" height="20" />}
                    />
                  }
                />

                <GlobalAnchorList
                  label={'Student Track'}
                  component={
                    <Box>
                      <Button
                        size="small"
                        onClick={() => window.open(`/my-workspace/studentTrack?leadId=${rowData?.lead_id}`, '_blank')}
                        variant="outlined"
                      >
                        <Icon style={{ marginRight: '3px' }} icon="carbon:view" width="20" height="20" />
                        <Typography variant="button">View</Typography>
                      </Button>
                    </Box>
                  }
                />

                <GlobalAnchorList
                  label={'Change Course'}
                  component={
                    <ChangeCourseAction
                      row={rowData}
                      source="crm"
                      onSuccess={() => dispatch(getDataForCrdAdmissionRegister(dispatchParams))}
                    />
                  }
                />
                <GlobalAnchorList label={'Whatsapp Share'} component={<WhatsappShare rowData={rowData} />} />
                <GlobalAnchorList
                  label={'Student Profile'}
                  component={
                    <ProfileViewAdmissionRegister
                      // url={getStudentsProfileForCRD}
                      // storeName={"crd"}
                      admNo={rowData?.admn_no}
                    />
                  }
                />
                <GlobalAnchorList
                  label={'Edit'}
                  component={
                    // <UpdateStudent
                    //   crm={crm}
                    //   row={rowData}
                    //   dispatchParams={dispatchParams}
                    // />
                    <Tooltip title={'Student Edit'}>
                      <span>
                        <Button
                          disabled={crm}
                          size="small"
                          onClick={() => window.open(`/my-workspace/student-edit/${rowData?.admn_no}`, '_blank')}
                          variant="outlined"
                        >
                          <Icon
                            style={{ marginRight: '3px' }}
                            icon="material-symbols:right-click-rounded"
                            width="20"
                            height="20"
                          />
                          <Typography variant="button">Click</Typography>
                        </Button>
                      </span>
                    </Tooltip>
                  }
                />
                <GlobalAnchorList
                  label={'Total Sessions'}
                  component={
                    <SubjectAndTotalsession
                      crm={crm}
                      leadId={rowData?.lead_id}
                      courseEnrollmentId={rowData?.course_enrollment_id}
                      isDisable={!rowData?.total_sessions}
                      dispatchParams={dispatchParams}
                    />
                  }
                />
                <GlobalAnchorList
                  label={'OGA Remarks'}
                  component={<OGARemarks CROAssignID={rowData?.cro_assignment_id} />}
                />
                <GlobalAnchorList
                  label={'Fee Per Session'}
                  component={
                    <Feepersession
                      CourseEnrollId={rowData?.course_enrollment_id}
                      isDisable={!rowData?.total_sessions}
                    />
                  }
                />
                <GlobalAnchorList
                  label={'Course Certificate'}
                  component={<CourseCertificate crm={crm} CourseEnrollmentId={rowData?.course_enrollment_id} />}
                />
                <GlobalAnchorList
                  label={'CRO Notes'}
                  component={
                    <Cronotes crm={crm} data={rowData?.cro_notes} courseEnrollmentId={rowData?.course_enrollment_id} />
                  }
                />
                <GlobalAnchorList
                  label={'CRO Tutor Mapping'}
                  component={
                    <Tooltip title={rowData?.is_subject_enrolled ? '' : 'Subject Not Enrolled'}>
                      <span>
                        <Button
                          disabled={!rowData?.is_subject_enrolled}
                          size="small"
                          onClick={() =>
                            window.open(`/my-workspace/cro-trainer-mapping?data=${MappingTrainerEncoded}`, '_blank')
                          }
                          variant="outlined"
                        >
                          <Icon
                            style={{ marginRight: '3px' }}
                            icon="material-symbols:right-click-rounded"
                            width="20"
                            height="20"
                          />
                          <Typography variant="button">Click</Typography>
                        </Button>
                      </span>
                    </Tooltip>
                  }
                />
                <GlobalAnchorList
                  label={'Evaluation Tracker'}
                  component={<EvaluationTrackerLanding admissionNo={rowData?.admn_no} name={rowData?.student_name} />}
                />
                <GlobalAnchorList
                  label={'Admission Status'}
                  component={<TerminationClearenceCRD crm={crm} CourseEnrollmentId={rowData?.course_enrollment_id} />}
                />
                <GlobalAnchorList
                  label={'Session Log CRM'}
                  component={
                    <SessionLog crm={crm} rowData={rowData} courseEnrollmentId={rowData?.course_enrollment_id} />
                  }
                />
                <GlobalAnchorList
                  label={'Session Log CRO'}
                  component={
                    <SessionLogCRO crm={crm} rowData={rowData} courseEnrollmentId={rowData?.course_enrollment_id} />
                  }
                />
                <GlobalAnchorList
                  label={'Student Attendance'}
                  component={
                    <Button variant="outlined" size="small" color="primary" onClick={handlenavigate}>
                      <Icon icon="mdi:eye" width="20" height="20" />
                      View
                    </Button>
                  }
                />
                <GlobalAnchorList
                  label={'Ledger View'}
                  component={
                    <Button variant="outlined" size="small" color="primary" onClick={handlenavigateLedger}>
                      <Icon icon="mdi:eye" width="20" height="20" />
                      View
                    </Button>
                  }
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default NewAdmissionRegisterLanding;
